/**
 * @author Martin Albarracin
 * @file index.jsx
 * @description VideoCalls Component.
 */

// Dependencies
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

// env variables
const passWord = 'NephroMeet';

const VideoCalls = ({ meetingId, name, email, apiKey, apiSecret }) => {
  const { t: translate } = useTranslation();
  const urlToRedirect = '/main/scheduled-appointments?redirect=allow';

  const displayZommVideoCall = () => {
    const zmmtgRoot = document.getElementById('zmmtg-root');
    zmmtgRoot.style.display = 'block';
  };
  const removeDisplayZommVideoCall = () => {
    const zmmtgRoot = document.getElementById('zmmtg-root');
    zmmtgRoot.style.display = 'hidden';
  };

  const startMeeting = (ZoomMtg) => {
    displayZommVideoCall();
    const signature = {
      meetingNumber: meetingId,
      apiKey,
      apiSecret,
      role: 0,
      success(responseSignature) {
        ZoomMtg.init({
          leaveUrl: urlToRedirect,
          isSupportAV: true,
          success: () => {
            ZoomMtg.join({
              signature: responseSignature.result,
              meetingNumber: meetingId,
              userName: name,
              apiKey,
              userEmail: email,
              passWord
            });
            ZoomMtg.leaveMeeting({
              success() {
                removeDisplayZommVideoCall();
              }
            });
          }
        });
      }
    };

    ZoomMtg.generateSignature(signature);
  };

  const getZoomLanguage = (ZoomMtg) => {
    if (i18next.language === 'es') {
      ZoomMtg.i18n.load('es-ES');
      ZoomMtg.i18n.reload('es-ES');
    } else {
      ZoomMtg.i18n.load('en-US');
      ZoomMtg.i18n.reload('en-US');
    }
  };

  useEffect(() => {
    import('@zoomus/websdk').then(({ ZoomMtg }) => {
      ZoomMtg.setZoomJSLib('https://source.zoom.us/1.9.8/lib', '/av');
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareWebSDK();
      ZoomMtg.record({ record: false });
      ZoomMtg.showMeetingHeader({ show: true });
      getZoomLanguage(ZoomMtg);
      startMeeting(ZoomMtg);
      const button = document.querySelector('.joinWindowBtn');
      if (button) button.textContent = translate('commons.join');
    });
  }, []);

  return <div></div>;
};

/**
 * @name VideoCalls.propTypes
 * @type { propTypes } React PropTypes.
 * @property { Number } meetingId - meeting Number from Zoom.
 * @property { String } name - user name to join to the meeting.
 * @property { String } email - user email to join to the meeting.
 */

VideoCalls.propTypes = {
  meetingId: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  apiKey: PropTypes.string.isRequired,
  apiSecret: PropTypes.string.isRequired
};

export default React.memo(VideoCalls);
